import {appUnload} from '@web/actions/application'
import sessionSyncCreator from '@web/middlewares/sessionSync'

import type {SubscriptionRootState as State} from '../../../interfaces'

export type SyncState = State

/**
 * 세선 스토리지에 싱크를 맞춰야하는 엑션들의 type 값들 모음
 */
const sessionSyncActions = [appUnload.type]

const createSessionKey = (state: State) => {
    const {
        common: {seqID},
    } = state

    return seqID ?? ''
}

const sessionSync = sessionSyncCreator<State>({
    actionWithSessions: sessionSyncActions,
    createSessionKey,
})

export default sessionSync
